import React from 'react';

const AccountDeleteInfo: React.FC = () => {

  return (
    <>
           <h2>How to Request Account Removal</h2>
           <p>To request account removal please send an email to info@eleveneagles.tech that includes your email address as well as the name of the project you were working on from the email address we have on file. We will promptly comply and delete your account as well as ALL data you have provided to us and respond when that data has been removed. We do not use your data for any marketing and it is not sold to anybody. The purpose of collecting your email address and name is strictly for the purposes of collaborating on your design project.</p>
        </>
  );
};

export default AccountDeleteInfo;
